<template lang="pug">
  section.hero(:class="componentClassName" :style="componentStyle")
    .hero-body
      slot
    .hero-background
</template>

<script>
import { getRandomInt } from '@/utils/number';

export default {
  name: 'ui-hero',

  props: {
    fullheight: Boolean,
  },

  data: () => ({
    // backgroundHost: '',
    backgroundHost: 'https://images.pexels.com/photos/',
    backgrounds: [
      // 'https://cdn.pixabay.com/photo/2017/03/17/18/03/bokeh-2152298_1280.jpg',
      // 'https://cdn.pixabay.com/photo/2018/03/16/04/40/grid-3230205_1280.jpg',
      // 'https://cdn.pixabay.com/photo/2016/06/22/11/10/box-1472804_1280.png',
      // 'https://cdn.pixabay.com/photo/2016/08/02/07/45/the-polygon-1562743_1280.jpg',
      // 'https://cdn.pixabay.com/photo/2018/03/15/07/10/grid-3227320_1280.jpg',

      '9754/mountains-clouds-forest-fog.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      '1403550/pexels-photo-1403550.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      '1487154/pexels-photo-1487154.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      // ok
      '911738/pexels-photo-911738.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      '1103970/pexels-photo-1103970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      '2457317/pexels-photo-2457317.png?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      // not
      '313782/pexels-photo-313782.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',

      '17668/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      '411595/pexels-photo-411595.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
      // '219692/pexels-photo-219692.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    ],
  }),

  computed: {
    componentClassName() {
      return {
        'is-fullheight': this.fullheight,
      };
    },

    componentStyle() {
      return {
        'background-image': `url(${this.getBackgroundImage()})`,
      };
    },
  },

  methods: {
    getBackgroundImage(index = null) {
      if (index === null) {
        index = getRandomInt(0, this.backgrounds.length - 1);
      }
      return this.backgroundHost + this.backgrounds[index];
    },
  },
};
</script>
